import { create } from 'zustand';
import type { ComponentType } from 'react';

interface DialogState {
  component: ComponentType<Record<string, unknown>> | null;
  props: Record<string, unknown> | null;
  isOpen: boolean;
  resolve: ((value: unknown) => void) | null;
  openDialog: <T = unknown>(
    Component: ComponentType<Record<string, unknown>>,
    options?: { componentProps?: Record<string, unknown> },
  ) => Promise<T>;
  closeDialog: () => void;
  submitDialog: (value?: unknown) => void;
}

export const useDialogStore = create<DialogState>((set, get) => ({
  component: null,
  props: null,
  isOpen: false,
  resolve: null,
  openDialog: (Component, options = {}) => {
    return new Promise((resolve) => {
      set({
        component: Component,
        props: options.componentProps || {},
        isOpen: true,
        resolve: resolve as (value: unknown) => void,
      });
    });
  },
  closeDialog: () => {
    const { resolve } = get();
    if (resolve) {
      resolve(undefined);
    }
    set({
      component: null,
      props: null,
      isOpen: false,
      resolve: null,
    });
  },
  submitDialog: (value) => {
    const { resolve } = get();
    if (resolve) {
      resolve(value);
    }
    set({
      component: null,
      props: null,
      isOpen: false,
      resolve: null,
    });
  },
}));
